<ng-container>
  <isophi-app-portfolio-plan-base-item
    #base
    *transloco="let t"
    [leftIcon]="'news'"
    [title]="t('portfolio/documents')"
    [rightIcon]="allowDownload ? '' : 'add_2'"
    [onCardClick]="onRightIconClick.bind(this)"
  >
    <div *ngIf="base.isViewMode() && documents.length > 0" class="documents-wrapper">
      <div class="document-row" *ngFor="let document of documents">
        <div class="document-title pointer" (click)="openPreview(document)">
          <span class="material-symbols-rounded"> description </span>
          {{ document.title || t('portfolio/untitledDocument') }}
        </div>

        <isophi-action-popup *ngIf="!allowDownload" [actionItems]="actionItems" (action)="onAction($event, document)"></isophi-action-popup>
        <span *ngIf="allowDownload" class="material-symbols-rounded pointer" (click)="downloadDocument.emit(document.file)">
          download
        </span>
      </div>
    </div>
  </isophi-app-portfolio-plan-base-item>
  <input #fileInput type="file" hidden (change)="handleFileChange($event)" />
</ng-container>
